import React from "react";

const GulliDandaAbout = ({ onClose }) => {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-95 text-white [&_p]:text-white [&_li]:text-white flex flex-col p-6 overflow-y-auto z-50">
      <h1 className="text-2xl mb-4">🏏 About Gulli Danda</h1>

      <p className="mb-4">
        Gulli Danda is a traditional Indian street game played in villages and
        towns. It involves striking a small stick (gulli) using a larger stick
        (danda) to send it flying as far as possible.
      </p>

      <h2 className="text-sm lg:text-lg text-yellow-200 mt-2 mb-2">🎮 How to Play</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>👆 Tap once to lift the gulli</li>
        <li>🔥 Tap again at the right time to hit</li>
        <li>🎯 Try to hit when power bar is near center</li>
        <li>🚀 Better timing = longer distance</li>
        <li>🏆 Score more to beat your best</li>
      </ul>

      <h2 className="text-sm lg:text-lg text-yellow-200 mt-2 mb-2">💡 Tips</h2>
      <ul className="list-disc pl-5 space-y-2">
        <li>⚖️ Middle power = perfect hit</li>
        <li>😬 Near miss still helps you learn timing</li>
        <li>🔁 Keep practicing to improve</li>
      </ul>

      <button
        onClick={onClose}
        className="mt-2 text-xs lg:text-sm w-20 lg:w-32 px-2 py-1 bg-white text-black rounded-md"
      >
        Close
      </button>
    </div>
  );
};

export default GulliDandaAbout;